import { successResponseSchema } from '@/api/resources/shared/success'
import { z } from 'zod'

export const assetsValueResponseSchema = successResponseSchema.extend({
  inventory_value: z.number(),
  // this will soon be required, waiting for BE update - Josh Dobson - 3/11/25
  points_available: z.number().nullable().optional()
})

export type AssetsValueResponse = z.infer<typeof assetsValueResponseSchema>
